/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxTextAreaComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtextarea';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcTextAreaComponent),
    multi: true
};

/**
 * Text Area
 */

export class NgcTextAreaComponent extends ControlComponent {
     displayMember: any;
     dropDownWidth: any;
     items: any;
     maxLength: any;
     minLength: any;
     opened: any;
     placeHolder: any;
     popupZIndex: any;
     query: any;
     renderer: any;
     roundedCorners: any;
     rtl: any;
     scrollBarSize: any;
     searchMode: any;
     source: any;
     theme: any;
     valueMember: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-textarea',
    template: `<jqxTextArea *ngIf="visible" (input)="inputChange($event)"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownWidth] = "dropDownWidth"
                [items] = "items"
                [maxLength] = "maxLength"
                [minLength] = "minLength"
                [opened] = "opened"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [query] = "query"
                [renderer] = "renderer"
                [roundedCorners] = "roundedCorners"
                [rtl] = "rtl"
                [scrollBarSize] = "scrollBarSize"
                [searchMode] = "searchMode"
                [source] = "source"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxTextArea>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'displayMember': [{ type: Input, args: ['displayMember', ] },],
'dropDownWidth': [{ type: Input, args: ['dropDownWidth', ] },],
'items': [{ type: Input, args: ['items', ] },],
'maxLength': [{ type: Input, args: ['maxLength', ] },],
'minLength': [{ type: Input, args: ['minLength', ] },],
'opened': [{ type: Input, args: ['opened', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'query': [{ type: Input, args: ['query', ] },],
'renderer': [{ type: Input, args: ['renderer', ] },],
'roundedCorners': [{ type: Input, args: ['roundedCorners', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'scrollBarSize': [{ type: Input, args: ['scrollBarSize', ] },],
'searchMode': [{ type: Input, args: ['searchMode', ] },],
'source': [{ type: Input, args: ['source', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'valueMember': [{ type: Input, args: ['valueMember', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Text Area Module
 */

export class NgcTextAreaModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcTextAreaComponent],
    declarations: [NgcTextAreaComponent, jqxTextAreaComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
